import { DocumentReportIcon, OfficeBuildingIcon, UsersIcon, IdentificationIcon, NewspaperIcon, HomeIcon, InboxInIcon, LightBulbIcon, DocumentSearchIcon} from '@heroicons/react/outline'

export const navigation = [
  {
    name: 'Dashboard',
    href: '/dashboard',
    icon: DocumentReportIcon,
    permission: ['admin'],
    parentOf: [],
  },
  {
    name: 'Properties',
    href: '/dashboard/properties',
    icon: HomeIcon,
    permission: ['*'],
    except: ['marketing'],
    parentOf: ['/dashboard/properties/edit/:propertyId'],
  },
  {
    name: 'Projects',
    href: '/dashboard/projects',
    icon: OfficeBuildingIcon,
    permission: ['admin', 'marketing'],
    parentOf: [],
  },
  {
    name: 'Enquiries',
    href: '/dashboard/enquiries',
    icon: InboxInIcon,
    permission: ['*'],
    except: ['marketing'],
    parentOf: [],
  },
  {
    name: 'Features',
    href: '/dashboard/features',
    icon: LightBulbIcon,
    permission: ['admin'],
    parentOf: [],
  },
  {
    name: 'Users',
    href: '/dashboard/users',
    icon: UsersIcon,
    permission: ['admin'],
    parentOf: [],
  },
  
  {
    name: 'Blog',
    href: '/dashboard/blogs',
    icon: NewspaperIcon,
    permission: ['admin', 'marketing'],
    parentOf: [],
  },

  {
    name: 'Pages',
    href: '/dashboard/pages',
    icon: DocumentSearchIcon,
    permission: ['admin', 'marketing'],
    parentOf: [],
  },
  {
    name: 'My Account',
    href: '/dashboard/account',
    icon: IdentificationIcon,
    permission: ['account-admin', 'seller'],
    parentOf: ['account-admin'],
  },
]

let {origin, hostname} = window.location
if (process.env.NODE_ENV === 'development') {
  origin = origin.replace(3000, '')
  if (hostname === 'localhost') origin = origin.replace('https', 'http')
}
export const appConfig = {
  projectName: 'Genie',
  domain: origin,
  apiEndPoint: `${origin}/api`
}

export const userNavigation = [
  { key: 'profile', name: 'My Profile', href: '/dashboard/profile' },
  { key: 'logout', name: 'Sign out', href: '#' },
]
